export default __webpack_public_path__ + "static/museo-sans-bold-cff41fd1ef51ba723f40a609a1592c0d.woff2";